<d3-modal-dialog
  #startAppModal
  uniqueId="startAppModal"
  headerText="Child information"
  calloutVariant="information"
  [hideUiElements]="true"
  (closeAction)="onModalClose()"
>
  <div body [formGroup]="formGroup" class="start-app-modal-component">
    <p>
      Please provide the full name of your child for whom you have not yet created an application, as it appears on
      their medical documents and other government issued ID.
    </p>

    <div class="form-field">
      <common-form-control label="Child’s First Name" [control]="formGroup.controls.firstName">
        <input type="text" data-cy="firstName" autocomplete="off" formControlName="firstName" />
      </common-form-control>
    </div>

    <div class="form-field">
      <common-form-control label="Child’s Middle Name" [control]="formGroup.controls.middleName">
        <input type="text" data-cy="middleName" autocomplete="off" formControlName="middleName" />
      </common-form-control>
    </div>

    <div class="form-field">
      <common-form-control label="Child’s Last Name" [control]="formGroup.controls.lastName">
        <input type="text" data-cy="lastName" autocomplete="off" formControlName="lastName" />
      </common-form-control>
    </div>

    <div class="button-footer">
      <span class="button"
        ><goab-button (onClick)="onAddChildContinue()" data-cy="continue" size="compact">Continue</goab-button></span
      >
      <span class="button"
        ><goab-button type="secondary" (onClick)="onAddChildCancel()" data-cy="cancel" size="compact"
          >Cancel</goab-button
        ></span
      >
    </div>
  </div>
</d3-modal-dialog>
